import { useEffect } from 'react';
import { useAppDispatch } from '../../store/hooks';
import { flushPendingSeals, loadPendingSeals } from './sealQueueSlice';

/**
 * Wires the offline seal queue to the browser.
 *
 *  - On mount: recover anything sealed in a previous offline session.
 *  - `online` event: the network is back; flush.
 *  - Service worker message: Background Sync fired (`sync-letters` in sw.js);
 *    the SW may have woken while the tab was closed, so flush regardless.
 */
export function useOfflineSync() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    void dispatch(loadPendingSeals());
    void dispatch(flushPendingSeals());

    const onOnline = () => void dispatch(flushPendingSeals());
    const onMessage = (e: MessageEvent) => {
      if (e.data?.type === 'flush-letter-queue') void dispatch(flushPendingSeals());
    };

    window.addEventListener('online', onOnline);
    navigator.serviceWorker?.addEventListener('message', onMessage);
    return () => {
      window.removeEventListener('online', onOnline);
      navigator.serviceWorker?.removeEventListener('message', onMessage);
    };
  }, [dispatch]);
}